module.exports = __webpack_public_path__ + "img/ipad_en.defad87.jpg";